const isArray = function isArrayPolyfill(_possibleArray) {
	/*
        Checks if _possibleArray is an array.
    */

	return Object.prototype.toString.call(_possibleArray) === "[object Array]";
};

export default isArray;
